/**
 * Re-applies the last known cell value when a modal closes without committing a change.
 * @module revertTableToLastStateIfOnClose
 */
import { CptCodesTableRowModel } from "../../../../../data-model/cptCodesTableModel";
import {
  AuthOnFile,
  GeneralOrderDetails,
} from "../../../../../data-model/medicalPaOrdersModel";
import { updateTableDataState } from "./updateTableDataState";

/**
 * Restores a single table cell from `fieldValue` when modal flows cancel.
 *
 * @param data - Row index, field key, prior value, order context, and state setters; no-op when omitted
 */
export const revertTableToLastStateOnClose = (data?: {
  rowIndex: number;
  fieldKey: string;
  fieldValue: any;
  // singleMedicalPaOrder: MedicalPaOrder;
  generalOrderDetails: GeneralOrderDetails | null | undefined;
  authOnFileDetails: AuthOnFile | null | undefined;
  originalTableData: CptCodesTableRowModel[];
  setTableData: React.Dispatch<React.SetStateAction<CptCodesTableRowModel[]>>;
  setHasChanges: React.Dispatch<React.SetStateAction<boolean>>;
  saveTableDataToContext: (data: CptCodesTableRowModel[]) => void;
  /** Healthcare facility `category` forwarded to the field reducers. */
  category?: string | null;
}) => {
  if (!data) return;
  const unwrappedGeneralOrderDetails = data.generalOrderDetails ?? null;
  const unwrappedAuthOnFileDetails = data.authOnFileDetails ?? null;
  updateTableDataState(
    data.rowIndex,
    data.fieldKey,
    data.fieldValue,
    unwrappedGeneralOrderDetails,
    unwrappedAuthOnFileDetails,
    data.originalTableData,
    data.setTableData,
    data.setHasChanges,
    data.saveTableDataToContext,
    data.category,
  );
};
